import {
  useListContext,
} from "react-admin";
import {
  FilterWrapper,
  FilterContainer,
  FilterSection,
  FIlterHeader,
  SectionHeader,
  SectionTitle,
  FilterInput,
  FilterSelectEl,
  WorkSpaceTitleRow,
} from "../../styles/commonStyles";
import { MenuItem, FormControl, InputLabel } from "@mui/material";
import TransactionButton from "../Common/TransactionButton";
import { FilterIcon } from "../Svg";
import { useState } from "react";

const MEAL_TYPES = [
  "STARTER",
  "MAIN COURSE",
  "DESSERT",
  "SIDE_DISH",
  "BEVERAGE",
];

const CuisineFilters = ({ categories }: { categories: any[] }) => {
  const { filterValues, setFilters } = useListContext();
  const [name, setName] = useState<String>(filterValues?.name || "")
 
  const updateFilter = (key: string, value: any) => {
    setFilters(
      { ...filterValues, [key]: value || undefined },
      null,
      false
    );
  };

  return (
    <FilterWrapper>
      <FIlterHeader>
        <FilterSection>
          <SectionHeader>
            <WorkSpaceTitleRow>
              <FilterIcon color="#1976d2" height={20} width={20} />
              <SectionTitle>Filters</SectionTitle>
            </WorkSpaceTitleRow>
          </SectionHeader>

          <TransactionButton
            name="Clear Filters"
            onClickHandler={() => {
              setName("");
              setFilters({}, null);
            }}
          />
        </FilterSection>
      </FIlterHeader>

      <FilterContainer>
        {/* Name */}
        <FilterInput 
          label="Name"
          size="small"
          variant="outlined"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            updateFilter("name", e.target.value);
          }}
        />

        {/* Meal Type */}
        <FormControl>
          <InputLabel>{!filterValues.mealType ? "Meal Type" : ""}</InputLabel>
          <FilterSelectEl
            size="small"
            label="Meal Type"
            variant="outlined"
            fullWidth
            value={filterValues.mealType || ""}
            onChange={(e) =>
              updateFilter("mealType", e.target.value)
            }
          >
            <MenuItem value="">Meal Type</MenuItem>
            {MEAL_TYPES.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </FilterSelectEl>
        </FormControl>

        {/* Category */}
        <FormControl>
          <InputLabel>{!filterValues?.categoryId ? "Category" : ""}</InputLabel>
          <FilterSelectEl
            size="small"
            label="Category"
            variant="outlined"
            fullWidth
            value={filterValues.categoryId || ""}
            onChange={(e) =>
              updateFilter("categoryId", e.target.value)
            }
          >
            <MenuItem value="">Meal Category</MenuItem>
            {categories.map((cat) => (
              <MenuItem key={cat.id} value={cat.id}>
                {cat.name}
              </MenuItem>
            ))}
          </FilterSelectEl>
        </FormControl>
      </FilterContainer>
    </FilterWrapper>
  );
};

export default CuisineFilters;
